module.exports = [
  {
    name: "default",
    interval: 150,
    frames: [
      {
        x: 431,
        y: 54, // + 31,
        width: 19,
        height: 20
      },
      {
        x: 453,
        y: 54, // + 31,
        width: 17,
        height: 20
      },
      {
        x: 478,
        y: 54, // + 31,
        width: 10,
        height: 20
      },
      {
        x: 453,
        y: 54, // + 31,
        width: 17,
        height: 20
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/ItemPoses.js